import { useCallback, useState } from "react";
import "./Locations.css";
import LocationPreview from "../../Components/LocationPreview/LocationPreview";
import ModalWindow from "../../Components/ModalWindow/ModalWindow";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeLocation } from "../../features/locationSlice";
import { logout } from "../../features/userSlice";
import {
  useFetchLocationsData,
  useRemoveLocation,
} from "../../hooks/useLocationData";
import { useFetchCategories } from "../../hooks/useCategory";
import Paginate from "../../Components/Paginate/Paginate";
import debounce from "lodash.debounce";

const ITEMS_PER_PAGE = 10;

const Locations = () => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(searchValue);
  const [searchCategory, setSearchCategory] = useState("");

  const [deleteLocation, setDeleteLocation] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const { mutate: deletingLocation } = useRemoveLocation();
  const [isRefetchingLocations, setIsRefetchingLocations] = useState(false);

  const [pageNumber, setPageNumber] = useState(1); // Start at 1 for API

  const { data: categories, isLoading: isLoadingCategories } =
    useFetchCategories();

  const { locations, isLoading, refetch } = useFetchLocationsData(
    debouncedSearchQuery,
    searchCategory,
    pageNumber,
    ITEMS_PER_PAGE
  );

  const dispatch = useDispatch();

  const confirmDeletingLocation = () => {
    setIsDeleting(true);
    deletingLocation(deleteLocation.id);
    setIsDeleting(false);
    setDeleteLocation(null);
  };

  const debouncedSetSearchQuery = useCallback(
    debounce((value) => {
      setDebouncedSearchQuery(value);
    }, 1000),
    []
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    debouncedSetSearchQuery(value);
    setPageNumber(1);
  };

  const handleLogOut = async (e) => {
    e.preventDefault();

    try {
      sessionStorage.removeItem("user");
      dispatch(logout());
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleRefetchLocations = async () => {
    setIsRefetchingLocations(true);
    try {
      await refetch();
    } catch (error) {
      console.log(error);
    } finally {
      setIsRefetchingLocations(false);
    }
  };

  if (isLoading || isLoadingCategories)
    return (
      <div className="invisibleWrapper">
        <p className="loadingText">Loading...</p>
      </div>
    );

  return (
    <div className="locationsWrapper">
      <div className="titleContainer">
        <p className="link">
          <Link to="/admin" onClick={() => dispatch(removeLocation())}>
            Admin panel
          </Link>
        </p>
        <h1>Pretraga lokacija</h1>
        <button className="logout" onClick={handleLogOut}>
          Izloguj se
        </button>
      </div>
      <div>
        <button onClick={handleRefetchLocations} style={{ margin: "0" }}>
          Osvezi lokacije
        </button>
      </div>
      <div className="searchboxWrapper">
        <div>
          <label>
            Pretraga lokaliteta se automatski pokrece nakon unosa dva karaktera
            u polje za pretragu
          </label>
          <input
            type="text"
            placeholder="Unesi naziv lokaliteta..."
            value={searchValue}
            onChange={handleSearchChange}
          />
        </div>
        <div className="selectCategoryContainer">
          <label>Izaberi kategoriju</label>
          <select
            defaultValue=""
            onChange={(e) => setSearchCategory(e.target.value)}
          >
            <option value="">Sve kategorije</option>
            {categories.map((category) => (
              <option key={category.id} value={category.id}>
                {category.nameLatin}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="locationsContainer">
        {locations?.locations.map((location) => {
          return (
            <LocationPreview
              key={location.id}
              location={{ ...location }} // Prikazuje primaryCategory
              setDeleteLocation={setDeleteLocation}
            />
          );
        })}
      </div>

      {searchValue === "" && (
        <div className="paginationButtonsContainer">
          <Paginate
            pageNumber={pageNumber}
            itemsPerPage={ITEMS_PER_PAGE}
            pageCount={Math.ceil((locations?.totalCount || 0) / ITEMS_PER_PAGE)}
            onPageChange={(page) => {
              setPageNumber(page);
            }}
          />
        </div>
      )}

      {deleteLocation && (
        <ModalWindow
          title="Da li ste sigurni da zelite da obrisete lokalitet?"
          setDeleteData={setDeleteLocation}
          confirmDeletingData={confirmDeletingLocation}
        />
      )}
      {(isLoading || isDeleting || isRefetchingLocations) && (
        <div className="invisibleWrapper">
          <p className="loadingText">Loading...</p>
        </div>
      )}
    </div>
  );
};

export default Locations;
